export enum Colors {
    b900 = 'rgba(0, 50.000000819563866, 100.00000163912773, 1)',
    b800 = 'rgba(10.856883823871613, 72.3164351284504, 133.7759256362915, 1)',
    b700 = 'rgba(35.61229705810547, 104.1914427280426, 172.77051240205765, 1)',
    b600 = 'rgba(74.13730502128601, 136.0664427280426, 197.99551963806152, 1)',
    b500 = 'rgba(98.97939920425415, 159.93948251008987, 220.89950501918793, 1)',
    b400 = 'rgba(157.67965257167816, 198.9000079035759, 240.1203328371048, 1)',
    b300 = 'rgba(186.04798793792725, 214.20000851154327, 242.35199868679047, 1)',
    b200 = 'rgba(225.54752200841904, 237.15001702308655, 248.75248163938522, 1)',
    b100 = 'rgba(242.67166793346405, 247.13086545467377, 251.59006297588348, 1)',
    n900 = 'rgba(0, 12.750006839632988, 25.50000037997961, 1)',
    n800 = 'rgba(67.64326348900795, 75.43750405311584, 83.23172941803932, 1)',
    n700 = 'rgba(126.43306285142899, 134.93749290704727, 143.44192296266556, 1)',
    n600 = 'rgba(161.38199150562286, 167.90820211172104, 174.4344127178192, 1)',
    n500 = 'rgba(185.5567654967308, 189.12500202655792, 192.69323855638504, 1)',
    n400 = 'rgba(218.4765574336052, 219.93750303983688, 221.39844864606857, 1)',
    n300 = 'rgba(228.76921713352203, 230.13086646795273, 231.49251580238342, 1)',
    n200 = 'rgba(237.71100372076035, 239.69999939203262, 241.6889950633049, 1)',
    n100 = 'rgba(246.0000005364418, 247.00000047683716, 248.0000004172325, 1)',
    o900 = 'rgba(158.9962363243103, 63.050696924328804, 0.6443846225738525, 1)',
    o800 = 'rgba(182.37264275550842, 89.5340484380722, 24.78164702653885, 1)',
    o700 = 'rgba(215.99214434623718, 113.85990992188454, 18.02348166704178, 1)',
    o600 = 'rgba(248.08928042650223, 133.91584932804108, 24.176354706287384, 1)',
    o500 = 'rgba(252.00000017881393, 149.00000631809235, 50.000000819563866, 1)',
    o400 = 'rgba(251.7499127984047, 175.01787900924683, 101.26570612192154, 1)',
    o300 = 'rgba(253.93164932727814, 202.06315577030182, 152.2089797258377, 1)',
    o200 = 'rgba(255, 223.71279805898666, 193.64061892032623, 1)',
    o100 = 'rgba(255, 238.8823440670967, 223.39062094688416, 1)',
    cherry = 'rgba(176.00000470876694, 1.0000000591389835, 58.00000034272671, 1)',
    coral = 'rgba(232.00000137090683, 110.00000104308128, 90.00000223517418, 1)',
    grape = 'rgba(120.00000044703484, 120.00000044703484, 255, 1)',
    ink = 'rgba(39.00000147521496, 30.00000011175871, 44.000001177191734, 1)',
    white = 'rgba(255, 255, 255, 1)',
    g900 = 'rgba(24.000000469386578, 86.00000247359276, 46.000001057982445, 1)',
    g800 = 'rgba(29.913438856601715, 132.6158630847931, 66.2067885696888, 1)',
    g700 = 'rgba(32.77950346469879, 156.1130726337433, 76.40772879123688, 1)',
    g600 = 'rgba(41.00000135600567, 176.00000470876694, 89.00000229477882, 1)',
    g500 = 'rgba(72.00000330805779, 187.00000405311584, 120.00000044703484, 1)',
    g400 = 'rgba(104.00000140070915, 211.00000262260437, 145.00000655651093, 1)',
    g300 = 'rgba(176.86198085546494, 226.88802927732468, 194.43869769573212, 1)',
    g200 = 'rgba(213.22431206703186, 241.5589052438736, 222.8701400756836, 1)',
    g100 = 'rgba(241.00000083446503, 249.00000035762787, 244.0000006556511, 1)',
    r900 = 'rgba(118.5000005364418, 39.50000524520874, 39.50003184378147, 1)',
    r800 = 'rgba(157.05520927906036, 51.194789707660675, 51.19482770562172, 1)',
    r700 = 'rgba(190.7187581062317, 64.28124189376831, 64.28128749132156, 1)',
    r600 = 'rgba(215.581234395504, 69.16876763105392, 69.16882082819939, 1)',
    r500 = 'rgba(244.5874947309494, 86.91249310970306, 86.91254630684853, 1)',
    r400 = 'rgba(241.00000083446503, 124.00000020861626, 124.00000020861626, 1)',
    r300 = 'rgba(254.99998480081558, 168.30000668764114, 168.30003708600998, 1)',
    r200 = 'rgba(254.504354596138, 207.91557133197784, 207.91558653116226, 1)',
    r100 = 'rgba(255, 234.59998905658722, 234.59998905658722, 1)',
}